import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Link from 'components/shared/Link';

type CheckoutLinkProps = {
  loading: boolean;
  redirectToReview: boolean;
};

function CheckoutLink(props: CheckoutLinkProps) {
  const { loading, redirectToReview } = props;

  return (
    <Link
      type="button"
      variant="outline"
      href={`/checkout${redirectToReview ? '/review' : ''}`}
      className={`checkout-button ${loading ? 'disabled' : ''}`}
    >
      {redirectToReview && (
        <React.Fragment>
          Return to Review Order
          <FontAwesomeIcon icon="arrow-right" />
        </React.Fragment>
      )}
      {!redirectToReview && (
        <React.Fragment>
          Checkout
          <FontAwesomeIcon icon="arrow-right" />
        </React.Fragment>
      )}
    </Link>
  );
}

export default CheckoutLink;
